//MUI
import MuiDrawer from '@mui/material/Drawer';
import { styled, Theme, CSSObject } from '@mui/material/styles';
import { List } from '@mui/material';

const openedMixin = (theme: Theme): CSSObject => ({
	width: theme.sizes.DRAWER_WIDTH,
	[theme.breakpoints.down('sm')]: { width: '100%' },
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),

	backgroundColor: theme.palette.nav.secondary,
	[theme.breakpoints.down('sm')]: {
		backgroundColor: '#fff',
		width: '100%',
		opacity: 1,
	},
	overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.shortest,
	}),
	backgroundColor: theme.palette.nav.secondary,
	overflowX: 'hidden',
	//width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
	[theme.breakpoints.down('sm')]: {
		transition: theme.transitions.create('opacity', {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.complex,
		}),
		width: '0',
		height: '100vh',
		opacity: 0,
	},
	'& .MuiPaper-root': {
		right: 'auto',
		borderLeft: '1px solid rgba(145, 158, 171, 0.24)',
		[theme.breakpoints.down('sm')]: {
			top: theme.sizes.APPBAR_MOBILE,
			height: '100vh',
			backgroundColor: '#f4fdfc',
		},
	},
});

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
	'& .MuiPaper-root': {
		right: 'auto',
		[theme.breakpoints.down('sm')]: {
			top: theme.sizes.APPBAR_MOBILE,
			height: '100vh',
			backgroundColor: '#f4fdfc',
		},
	},
	width: theme.sizes.DRAWER_WIDTH,
	[theme.breakpoints.down('sm')]: { width: '0', height: '100vh' },
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
		right: 'auto',
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));

export const DrawerHeader = styled('div')<{ open: boolean }>(({ theme, open }) => ({
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
	height: theme.sizes.APPBAR_MOBILE,
	[theme.breakpoints.down('sm')]: {
		margin: '24px',
	},
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	'& .muirtl-1x85g6d': {
		display: 'flex',
		alignItems: 'center',
		justifyContent: open ? ' unset' : 'center',
		width: '100%',
	},
	'& img': {
		width: open ? 'unset' : '29px',
		marginLeft: open ? '36px' : '0px',
		cursor: 'pointer',
	},
	'& svg': {
		cursor: 'pointer',
		transition: theme.transitions.create('margin', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
}));

export const IconButton = styled('div')(() => ({
	alignItems: 'center',
	display: 'flex',
	height: '100%',
}));

export const CustomList = styled(List)(({ theme }) => ({
	[theme.breakpoints.down('sm')]: {
		position: 'absolute',
		background: 'white',
		width: '100%',
		top: theme.spacing(12),
	},
	'& .MuiListItem-root': {
		marginBottom: '5px',
	},
}));

export const sxSelected = (theme, selected, open) => {
	return {
		width: '100%',
		marginLeft: open ? '18px' : '',
		[theme.breakpoints.down('sm')]: { marginLeft: '18px' },
		fontFamily: 'arial!important',
		'& .MuiTypography-body1': {
			fontFamily: selected ? 'RubikSemiBold' : 'inherit',
			fontSize: '14px',
		},
		'&:before': {
			width: `calc(100% - ${open ? '36px' : '16px'})`,
			height: '100%',
			left: open ? '18px' : '8px',
			content: "''",
			position: 'absolute',
			fontFamily: 'Arial',
			backgroundColor: selected ? 'rgba(47 ,229 ,207, 0.2)' : 'inherit',
			//opacity:'0.2',
			borderRadius: '12px',
		},
		/*'&:hover': {
            '&:before':{
                width: `calc(100% - ${open ? '36px' : '16px'})`,
                height:'100%',
                left:open ? '18px' : '8px',
                content: "''",
                position:'absolute',
                backgroundColor:theme.palette.root.brandPrimary,
                opacity:'0.2',borderRadius:'12px'
            }
        }*/
	};
};
